import type { ColorPickerProps as AntdColorPickerProps } from "antd-new";
import { ColorPicker as AntdColorPicker } from "antd-new";
import React from "react";

export interface ColorPickerProps extends AntdColorPickerProps {}

const ColorPicker = (props: ColorPickerProps) => {
  return <AntdColorPicker {...props} />;
};

export default ColorPicker;
